import { createStyles } from '@mantine/core';

export default createStyles((theme) => ({
  decadeLevel: {},

  calendarHeader: {
    marginBottom: theme.spacing.xs,
  },
}));
